import React, { useState } from "react";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const SellerFarmerFaqComp = () => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const faqs = [
    {
      question: "How do I add my produce?",
      answer:
        "Navigate to the Produce section from the sidebar and click on 'Add' button to add your produce details.",
    },
    {
      question: "How do I update my profile?",
      answer:
        "Go to Profile & Visibility tab and update your personal information, then click Submit.",
    },
    {
      question: "How do I contact support?",
      answer:
        "You can reach our support team through the Support section. You can chat, email, or call us.",
    },
    {
      question: "How do I change my password?",
      answer:
        "Go to the Security tab in your profile settings to change your password.",
    },
    {
      question: "What is KYB verification?",
      answer:
        "KYB (Know Your Business) verification is required to verify your business details before you can fully use the platform.",
    },
    {
      question: "How long does KYB approval take?",
      answer:
        "KYB verification typically takes 2-3 business days after submission.",
    },
  ];

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <div className="table-header" style={{ marginBottom: "20px" }}>
          <div className="header-text">
            <div className="head-text">Frequently Asked Questions</div>
            <div className="head-subtext">Find answers to common questions</div>
          </div>
        </div>
        {faqs.map((faq, index) => (
          <Accordion
            key={index}
            expanded={expanded === `panel${index}`}
            onChange={handleChange(`panel${index}`)}
            sx={{
              marginBottom: "10px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                backgroundColor:
                  expanded === `panel${index}` ? "#fff3e0" : "#f5f5f5",
              }}
            >
              <Typography sx={{ fontWeight: 500 }}>{faq.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography color="textSecondary">{faq.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </div>
  );
};

export default SellerFarmerFaqComp;
